import { FC, ReactElement, ReactFragment, ReactNode } from 'react';

import { IconColor, IconHoveredColor, IconDisabledColor } from '@hh.ru/magritte-ui-icon';
import { ChevronRightOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { Text, TextProps, TextDynamic } from '@hh.ru/magritte-ui-typography';

import styles from './styles.less';

export type CellRightLabelProps = {
    badge?: ReactNode;
    /** Стиль текста */
    style?: TextProps['style'];
    /** Цвет иконки */
    iconInitial?: IconColor;
    /** Цвет иконки в состоянии disabled */
    iconDisabled?: IconDisabledColor;
    /** Цвет иконки в состоянии hovered */
    iconHighlighted?: IconHoveredColor;
    'data-qa'?: string;
} & (
    | {
          children: ReactElement | string | number | ReactFragment;
          /** Бейдж */
          badge?: never;
          /** Флаг отображения иконки */
          hideIcon: boolean;
      }
    | {
          children?: ReactElement | string | number | ReactFragment;
          badge?: ReactNode;
          hideIcon?: never;
      }
);
export const CellRightLabel: FC<CellRightLabelProps> = ({
    style = 'secondary',
    iconInitial = 'secondary',
    iconDisabled = 'secondary',
    iconHighlighted = 'secondary',
    badge,
    hideIcon = false,
    'data-qa': dataQa = 'cell-chevron',
    children,
}) => {
    return (
        <div className={styles.label} data-qa={dataQa}>
            {children && (
                <TextDynamic>
                    <Text style={style} typography="label-2-regular">
                        {children}
                    </Text>
                </TextDynamic>
            )}
            {badge && <div className={styles.item}>{badge}</div>}
            {!hideIcon && (
                <div className={styles.item}>
                    <ChevronRightOutlinedSize24
                        initial={iconInitial}
                        highlighted={iconHighlighted}
                        disabled={iconDisabled}
                    />
                </div>
            )}
        </div>
    );
};
